
import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import TabStrip from '../../../organisms/Tabstrip';
import { _getComponent } from '../../../organisms/Tabstrip/getComponent';
import { Box } from '@mui/material';
import ClientManagement from './ClientManagement';
import Departments from './Departments';
import RoleManagement from './RoleManagement';
import NotificationPermissions from './Notificatons';
import BusinessSegment from './BusinessSegment';
// import NotificationPermissions from './Notificatons';

const Settings = () => {
  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const isAdmin = accessData?.role?.label === "Admin";

  // Get access for each module
  const clientManagementAccess = 
    accessData?.access?.find((module) => module.module === "Client Management") || {};
  const departmentAccess = 
    accessData?.access?.find((module) => module.module === "Department") || {};
  const roleManagementAccess = 
    accessData?.access?.find((module) => module.module === "Role Management") || {};
  const businessSegmentAccess = 
    accessData?.access?.find((module) => module.module === "Business Segment") || {};

  const notification = accessData?.access?.find((module) => module.module === "Notifications") || {};

  // Determine which tabs to show based on access
  const showClientManagement = isAdmin || clientManagementAccess?.is_view;
  const showDepartments = isAdmin || departmentAccess?.is_view;
  const showRoleManagement = isAdmin || roleManagementAccess?.is_view;
  const showBusinessSegment = isAdmin || businessSegmentAccess?.is_view;
  const showNotification = isAdmin || notification?.is_view;

  const [activeTab, setActiveTab] = useState("");

  const onTabChange = (event, value) => {
    setActiveTab(value);
  };

  const data = useMemo(() => {
    const tabs = [];
    
    // if (showClientManagement) {
    //   tabs.push({
    //     id: 1,
    //     label: "Client Management",
    //     view: <ClientManagement />,
    //   });
    // }

    if (showBusinessSegment) {
      tabs.push({
        id: 0,
        label: "Business Segment",
        view: <BusinessSegment />,
      });
    }

    if (showDepartments) {
      tabs.push({
        id: 1,
        label: "Departments",
        view: <Departments />,
      });
    }

    if (showRoleManagement) {
      tabs.push({
        id: 2,
        label: "Role Management",
        view: <RoleManagement />,
      });
    }

    if (showNotification) {
      tabs.push({
        id: 3,
        label: "Notifications",
        view: <NotificationPermissions />,
      });
    }
   

    // Set initial active tab if not set and there are tabs
    if (tabs.length > 0 && !activeTab) {
      setActiveTab(tabs[0].label);
    }

    return tabs;
  }, [showClientManagement, showDepartments, showRoleManagement, activeTab]);

  return (
    <>
      {data.length > 0 ? (
        <>
          <TabStrip activeTab={activeTab} onTabChange={onTabChange} data={data} />
          <Box sx={{ width: "100%" }}>
            <Box sx={{ p: '20px 40px' }}>{_getComponent(data, activeTab)}</Box>
          </Box>
        </>
      ) : (
        <Box sx={{ p: '20px 40px' }}>
          You don't have access to any settings modules.
        </Box>
      )}
    </>
  );
};

export default Settings;